import {
  MILL_PROGRESS,
  MILL_MAP_PROGRESS,
  GET_MILLS,
  SELECT_MILL,
  SET_FILTER,
  IS_PDF,
  IS_IN_EXTENT,
} from "./types";

import axios from "axios";
import { returnErrors, returnSuccess } from "./messageActions";
import { setCarousel } from "./settingActions";

export const getMills = () => (dispatch) => {
  axios
    .get(
      `https://geoportal.kreis-herford.de/gis/rest/services/KR/Muehlen/FeatureServer/0/query?where=OBJECTID%3C99999&outFields=Objektnr,Name,Antriebsart,Gemeinde,GebäudeVorhanden,Thumb,PDF,HTML,Bilder&f=geoJson`
    )
    .then((res) => {
      if (res.data.features) {
        //var data = res.data;
        //data.features.map(feature => {feature.properties.Bilder = feature.properties.Bilder.split(', '); return feature});
        dispatch({
          type: GET_MILLS,
          payload: res.data,
        });
        dispatch(returnSuccess(res.data.message, res.status));
      } else {
        dispatch(returnErrors(res.data.message, res.status, "GET_MILLS_FAIL"));
      }
      dispatch({ type: MILL_PROGRESS });
    })
    .catch((err) => {
      console.log(err);
      if (err.response) {
        dispatch(
          returnErrors(
            err.response.data.message,
            err.response.status,
            "GET_MILLS_FAIL"
          )
        );
      }
      dispatch({ type: MILL_PROGRESS });
    });
};

export const setMapProgress = () => (dispatch) => {
  dispatch({ type: MILL_MAP_PROGRESS });
};

export const selectMill = (mill, art) => (dispatch) => {
  if (!mill) {
    mill = {};
  } else if (mill && art) {
    mill.art = art;
  }
  dispatch({
    type: SELECT_MILL,
    payload: {
      selected: mill,
    },
  });
};

export const setFilter = (property, value, toBeSet) => (dispatch, getState) => {
  var filter = getState().mill.filter;
  var filteredProperty = filter[property];
  if (toBeSet) {
    filteredProperty.push(value);
  } else {
    filteredProperty = filteredProperty.filter((val) => val !== value);
  }
  filter[property] = [...filteredProperty];
  dispatch({
    type: SET_FILTER,
    payload: filter,
  });
};

export const setTimeFilter = (time) => (dispatch, getState) => {
  var filter = getState().mill.filter;
  if (time) {
    filter.time = [time];
  } else {
    filter.time = [];
  }
  dispatch({
    type: SET_FILTER,
    payload: filter,
  });
};

export const resetFilter = () => (dispatch, getState) => {
  var filter = getState().mill.filter;
  filter.municipality = [];
  filter.propulsion = [];
  filter.exists = [];
  dispatch({
    type: SET_FILTER,
    payload: filter,
  });
};

export const isPdf = (bool) => (dispatch) => {
  bool ? dispatch(setCarousel("images")) : dispatch(setCarousel("mills"));
  dispatch({
    type: IS_PDF,
    payload: bool,
  });
};

export const inExtent = (polygon) => (dispatch) => {
  dispatch({
    type: IS_IN_EXTENT,
    payload: polygon,
  });
};
